export const data = [
    {
        id: 1,
        name: "Rishav Nepal",
        title: "Network Specialist",
        img:
          "./assets/rishav.jfif",
        icon: "assets/twitter.png",
        desc:
          "Rocky has a very creative mindset, he can find solution to any problems.",
      },
      {
        id: 2,
        name: "Shiva Basyal",
        title: "Network Engineer at Nextgensm",
        img:
          "./assets/shiva.jfif",
        icon: "assets/linkedin.png",
        desc:
          "Working with Rocky is always fun and productive. He is a good mate.",
        featured: true,
      },
      {
        id: 3,
        name: "Ahasanaul Haque",
        title: "RM at MacDonalds",
        img:
          "./assets/ahasanaul.jpg",
        icon: "assets/linkedin.png",
        desc:
          "Whenever Rocky is on shift, our restaurant efficieny is highly improved. I love his work ethics.",
      },
];